import Icon from "@mui/material/Icon";
import Dashboard from "layouts/dashboard";
import ServiceProfileWithCompletion from "layouts/tables/services/service_profile_completion";
import UserProfile from "layouts/tables/services/vendor_availability";
import api from 'core/interceptors/api';
import Swal from 'sweetalert2';


const routeServices = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    permissionKey: "dashboard",
  },
  
  {
    type: "collapse",
    name: "User Profile",
    key: "user-profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/services/UserProfile",
    component: <UserProfile />,
    permissionKey: "user_profile",
  },
];

export default routeServices;

export const fetchAndFilterRoutesServices = async (vendorEmail) => {
  try {
    const res = await api.get(`/service_control/get_permissions?email=${vendorEmail}`);
    const permissions = res.data.permissions;  // ✅ Correctly extract permissions

    console.log("Permissions fetched successfully:", permissions);

    const filterRoutes = (routes) =>
      routes
        .map((route) => {
          if (route.children) {
            return permissions[route.permissionKey] ? route : null;
          }
          return permissions[route.permissionKey] ? route : null;
        })
        .filter(Boolean); // ✅ Remove null values

    const filteredRoutes = filterRoutes(routeServices);
    console.log("Filtered Routes:", filteredRoutes);
    return filteredRoutes;
  } catch (error) {
    console.error("Error fetching permissions:", error);
    Swal.fire("Error", "Failed to load permissions", "error");
    return [];
  }
};